<template>
    <div class="doshi_box">
        <div class="key_topTit">
            <div>Doshii</div>
            <div class="search">
                <input type="text" @input="searchList" v-model="keyWord" />
            </div>
        </div>
        <div class="key_topBtn_group">
            <div class="keyTop_btn" style="color:#EA3796;border-color:#EA3796;">New Request</div>
            <div class="keyTop_btn">Linked</div>
        </div>
        <div>
			<el-table
			:data="tableData"
			class="roster_table doshi-table"
			style="width: 100%">
				<el-table-column
				prop="title"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="ID">
                6G1qwAog
				</el-table-column>
				<el-table-column
				prop="sort"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="VENUE NAME">
                    PEISO Test Venue
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="VENDOR">
                PEISO POS-1
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="ADDRESS">
                30 Hay Street Donvale VIC 3000
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="PHONE NUMBER">
                0400 000 000
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="REQUEST TIME">
                09:00 AM 20/10/2019
				</el-table-column>
				<el-table-column
				prop="address"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="OPERATION">
					<template slot-scope="scope">
                        <div class="key_tableBtn_group">
                            <div class="key_delBtn" @click="toDetail(scope.row.id)">Details</div>
                        </div>
					</template>
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
                    :current-page.sync="page"
                    @current-change='changePage'
					layout="prev, pager, next"
					:page-size="10"
					:total="total">
				</el-pagination>
			</div>
		</div>
    </div>
</template>

<script>
import api from '../../api/dishi'
export default {
    data() {
        return {
            tableData:[1,2,3,4,5], // 主体表格
            page: 1,
            size: 10,
            total: 0,
            loading: true, // 主体表格加载
            keyWord:'',
            timeout:null
        }
    },
    methods: {
        searchList() {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.page = 1
                this.getLists.call(this)
            }, 2000) 
        },
        getLists(){
            var that = this
            api.getDoshiList(
                {
                    pageNum: that.page,
                    pageSize: that.size,
                    type:1,
                    keyword:this.keyWord
                },
                that.listCallback
            )
        },
        changePage(page){
            this.page=page
            this.getLists()
        },
        toDetail(id) {
            window.sessionStorage.setItem('doshiId',id)
            this.$router.push('/venueInfo-doshi')
            // api.deleteKeywords({params:{id:id},callback:res=>{
            //     let {code,message,data}=res.data;
            //     if(code==0){
            //         this.getLists()
            //     }else{
            //         this.$box.alert('', res.data.message, 'error')
            //     }
            // }})
        },
        // 列表回调
        listCallback (res) {
            var that = this
            that.loading = false
            if (res.data.code == 0) {
                that.total = res.data.data.total
                that.tableData = res.data.data.list
            } else {
                that.$box.alert('', res.data.message, 'error')
            }
        }
    },
    mounted() {
        this.getLists()
    },
}
</script>

<style lang="scss">
    .doshi_box{
        .key_topTit{
            display: flex;
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 40px;
            .search{
                margin-left: auto;
                width: 300px;
                border-bottom: 1px solid #fff;
                background-size: 24px 22px;
                background-position: left center;
                background-repeat: no-repeat;
                background-image: url('../../assets/s.png');
                margin-top: -3px;
                input{
                    outline: none;
                    border: none;
                    line-height: 30px;
                    font-size: 16px;
                    font-family:'PingFangSC-Regular,PingFang SC';
                    width: 100%;
                    background-color: transparent;
                    color: #fff;
                    box-sizing: border-box;
                    padding-left: 30px;
                }
            }
        }
        .key_topBtn_group{
            display: flex;
            .keyTop_btn{
                width: 280px;
                height: 60px;
                line-height: 60px;
                font-size:26px;
                font-weight:600;
                color: #fff;
                margin-right: 30px;
                margin-bottom: 30px;
                border: 2px solid #fff;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                .key_numBox1{
                    float: right;
                    box-sizing: border-box;
                    text-align: center;
                    width:30px;
                    height:30px;
                    background:rgba(234,55,150,1);
                    color: #fff;
                    font-size:16px;
                    font-weight: 600;
                    line-height: 30px;
                    // padding: 2px;
                    border-radius: 50%;
                    margin-right: 20px;
                    margin-top: 14px;
                }
            }
        }
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: center;
        }
        .key_delBtn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/doshi/index.vue